import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '@/components/painting/Home';
import About from '@/components/painting/About';
import Services from '@/components/painting/Services';
import Gallery from '@/components/painting/Gallery';
import ServiceAreas from '@/components/painting/ServiceAreas';
import Contact from '@/components/painting/Contact';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/service-areas" element={<ServiceAreas />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
